import Swiper, { Lazy, Pagination } from "swiper";

function swiperInit() {
  new Swiper(".listing-gallery", {
    loop: false,
    slidesPerView: 1, // Чтобы размер фоток был как в CSS, делаем auto
    lazy: { loadPrevNext: true },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    direction: "horizontal",
  });
}

// ajax подгрузка товаров
$(document).ajaxComplete(function (event, xhr, settings) {
  if (settings.url == "/assets/components/msearch2/action.php") {
    swiperInit();
  }
});

swiperInit();
